import {useQuery} from '@tanstack/react-query'

import {type GetVerificationStatusResponse} from '#/lib/wsoc/quicklogin/types'
import {createQueryKey} from '#/state/queries/util'
import {useAgent, useSession} from '#/state/session'

const RQKEY_ROOT = 'verificationStatus'

export function useVerificationStatusQuery({enabled}: {enabled: boolean}) {
  const agent = useAgent()
  const {currentAccount} = useSession()

  return useQuery<GetVerificationStatusResponse>({
    queryKey: createQueryKey(RQKEY_ROOT, {did: currentAccount?.did}),
    queryFn: ({signal}) => agent.quicklogin.getVerificationStatus({signal}),
    enabled: enabled && !!currentAccount?.did,
    staleTime: 0,
    gcTime: 0,
    refetchInterval: q => (q.state.data?.verified ? false : 2000),
  })
}
